import { render } from "./EmailSubscription.vue?vue&type=template&id=6cf0f2b6"
import script from "./EmailSubscription.vue?vue&type=script&lang=js"
export * from "./EmailSubscription.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__